import FuncaoSegundoGrau from "../components/FuncaoSegundoGrau/index.jsx"; 
import FuncaoPrimeiroGrau from "../components/FuncaoPrimeiroGrau/index.jsx"; 
import FuncaoSenoidal from "../components/FuncaoSenoidal/index.jsx"; 
import FuncaoCossenoidal from "../components/FuncaoCossenoidal/index.jsx"; 
import FuncaoTangente from "../components/FuncaoTangente/index.jsx"; 
import FuncaoBiquadratica from "../components/FuncaoBiquadratica/index.jsx"; 
import FuncaoExponencial from "../components/FuncaoExponencial/index.jsx"; 
import FuncaoLogaritmica from "../components/FuncaoLogaritmica/index.jsx"; 
import FuncaoModular from "../components/FuncaoModular/index.jsx"; 
import FuncaoConstante from "../components/FuncaoConstante/index.jsx"; 
import FuncaoPolinomial from "../components/FuncaoPolinomial/index.jsx"; 

const formulasMap = {
    funcaoPrimeiroGrau: <FuncaoPrimeiroGrau />,
    funcaoSegundoGrau: <FuncaoSegundoGrau />,
    funcaoBiquadratica: <FuncaoBiquadratica />,
    funcaoPolinomial: <FuncaoPolinomial />,
    funcaoExponencial: <FuncaoExponencial />,
    funcaoLogaritmica: <FuncaoLogaritmica />,
    funcaoModular: <FuncaoModular />,
    funcaoConstante: <FuncaoConstante />,
    funcaoSenoidal: <FuncaoSenoidal />,
    funcaoCossenoidal: <FuncaoCossenoidal />,
    funcaoTangente: <FuncaoTangente />,
};

export default function FormulaRender({ formula }) {
    return formulasMap[formula] || null;
}